const DownloadButtonConstAR = {
  downloadFile: 'تحميل',
};

export default DownloadButtonConstAR;
